import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useAuthUserRestaurant,
  useGetRestaurantCompanyTrackLocationsQuery,
} from '@durma-soft/gros-sdk';

import { Link } from '@/components/shared/link';
import { DataTable } from '@/components/shared/data-table';
import { buttonVariants } from '@/components/shared/shadcn-ui/button';
import { CreateRestaurantCompanyTrackLocationModal } from '@/components/restaurant/companies/create-restaurant-company-track-location-modal';
import { CompanyBreadcrumb } from '@/components/restaurant/companies/company-breadcrumb';

import { columns } from '@/config/restaurant/company-track-locations';
import { EditRestaurantCompanyTrackLocationModal } from '@/components/restaurant/companies/edit-restaurant-company-track-location-modal';

const RestaurantCompanyTrackLocations = () => {
  const { t } = useTranslation();

  const restaurant = useAuthUserRestaurant();
  const { companyId, trackLocationId } = useParams();

  if (!companyId) {
    throw new Error('Company ID are required getting location');
  }
  const memoizedColumns = useMemo(() => {
    return columns(t);
  }, [t]);

  const { data, isLoading } = useGetRestaurantCompanyTrackLocationsQuery({
    restaurant_id: restaurant.id,
    company_id: Number(companyId),
  });

  return (
    <>
      <Helmet>
        <title>{t('company.track-location.title')}</title>
      </Helmet>
      <CompanyBreadcrumb
        companyId={Number(companyId)}
        items={[
          {
            label: t('company.track-location.title'),
            to: `/restaurant/companies/${companyId}/track-locations`,
          },
        ]}
      />
      <div>
        <div className="flex items-center">
          <h1 className="text-lg font-semibold md:text-2xl">
            {t('company.track-location.title')}
          </h1>
        </div>
        <div className="flex flex-col gap-3">
          <div className="self-end">
            <Link
              to={`/restaurant/companies/${companyId}/track-locations/create`}
              className={buttonVariants({ variant: 'default' })}
            >
              {t('company.track-location.create')}
            </Link>
          </div>
          <DataTable
            columns={memoizedColumns}
            data={data}
            isLoading={isLoading}
          />
        </div>
      </div>
      <CreateRestaurantCompanyTrackLocationModal />
      {Boolean(trackLocationId) && (
        <EditRestaurantCompanyTrackLocationModal
          key={trackLocationId + companyId}
        />
      )}
    </>
  );
};

export default RestaurantCompanyTrackLocations;
